<template>
  <div>
    <van-popup v-model="show" :closeable="true" @close="close">
      <div class="content active">
        <h1>领取成功&nbsp;快去查看吧～</h1>
        <img v-if="!qqUrL" src="@/assets/img/newUser/success.png" />
        <div v-else class="group">
          <img :src="qqUrL" />
          <p>新人入群福利多多哦～</p>
        </div>
        <button @click="jumpPage">去查看</button>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  props: {
    showSuccess: {
      type: Boolean,
      default: false,
    },
    qqUrL: {
      type: String,
      default: '',
    },
    showType: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    showSuccess(status) {
      this.show = status;
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    close() {
      this.$emit('closeSuccess', true);
    },
    jumpPage() {
      // alert(this.showType);
      if (this.showType === 2) {
        this.toMyCoupon();
      } else {
        this.toMyCourse();
      }
    },
    toMyCoupon() {
      this.$router.push({ path: '/personalCenter/myCoupon' });
    },
    toMyCourse() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goLearnCenterPage', {}, false);
      } else {
        this.$router.push({ path: '/personalCenter/mycourseList' });
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .van-popup--center {
  border-radius: 8px;
}
::v-deep .van-popup__close-icon {
  color: #666;
}
.content.active {
  height: 712px;
}
.content {
  width: 640px;
  height: 614px;
  padding-top: 100px;
  > h1 {
    color: #ff6c02;
    font-weight: 500;
    font-size: 36px;
    text-align: center;
  }
  > img {
    display: block;
    width: 204px;
    height: 204px;
    margin: 64px auto;
  }
  .group {
    //   display: flex;
    //   flex-wrap: wrap;
    //   justify-content: center;

    img {
      display: block;
      width: 228px;
      height: 228px;
      margin: 80px auto 0;
    }
    p {
      padding: 46px 0 44px 0;
      color: #a5a5a5;
      font-size: 24px;
      text-align: center;
    }
  }
  > button {
    display: block;
    width: 432px;
    height: 88px;
    margin: 0 auto;
    color: #fff;
    font-size: 32px;
    line-height: 88px;
    text-align: center;
    background: #ff6c02;
    border-radius: 44px;
  }
}
</style>
